<template>
  <div class="shelves-log">
    <Search ref="search" @search="search"/>
    <Table :list="logList" @show-down-progress="showDownProgress" :subCode="subCode" @refresh="search" />
     <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>

    <!-- 从平台店铺下载进度弹窗和结果弹窗 -->
    <DownloadProgress
      ref="progressDialog"
    >
      <template v-slot:title>
        <span class="down-title">商品下载中...</span>
      </template>
    </DownloadProgress>
    <DownloadResult 
      :visible.sync="resultVisible"
      :resultData="resultData"
      :isShowBtn="false"
      @search="search"
    >
      <template v-slot:title>
        <span class="down-title">商品下载完成</span>
      </template>
    </DownloadResult>
    <!-- 从快麦ERP导入进度弹窗和结果弹窗 -->
    <DownloadProgress
      ref="erp_progressDialog"
    >
      <template v-slot:title>
        <span class="down-title">商品导入中...</span>
      </template>
    </DownloadProgress>
    <DownloadResult 
      :visible.sync="erp_resultVisible"
      :resultData="erp_resultData"
      :isShowBtn="false"
      @search="search"
    >
      <template v-slot:title>
        <span class="down-title">商品导入完成</span>
      </template>
    </DownloadResult>
    <!-- 从分销商品导入进度弹窗和结果弹窗 -->
    <DownloadProgress
      ref="dis_progressDialog"
    >
      <template v-slot:title>
        <span class="down-title">商品导入中...</span>
      </template>
    </DownloadProgress>
    <DownloadResult 
      :visible.sync="dis_resultVisible"
      :resultData="dis_resultData"
      :isShowBtn="false"
      @search="search"
    >
      <template v-slot:title>
        <span class="down-title">商品导入完成</span>
      </template>
    </DownloadResult>
    <!-- 从供销商展架导入进度弹窗和结果弹窗 -->
     <DownloadProgress
      ref="sup_progressDialog"
    >
      <template v-slot:title>
        <span class="down-title">商品导入中...</span>
      </template>
    </DownloadProgress>
    <DownloadResult 
      :visible.sync="sup_resultVisible"
      :resultData="sup_resultData"
      :isShowBtn="false"
      @search="search"
    >
      <template v-slot:title>
        <span class="down-title">商品导入完成</span>
      </template>
    </DownloadResult>
  </div>
</template>

<script>
import Search from './components/search.vue';
import Table from './components/table.vue';

import {getOperatorLog} from "@/servers/prod/log"
import { mapGetters, mapActions } from "vuex";
import DownloadProgress from '@/components/prod/center/components/DownloadProgress.vue'
import DownloadResult from '@/components/prod/center/components/DownloadResult.vue'

export default {
  components: {
    Search,
    Table,
    DownloadProgress,
    DownloadResult
  },
  data() {
    return {
      logList: [], // 表格数据
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      // 从平台商品下载
      resultVisible: false,
      resultData: {
        successNum: 0,
        totalNum: 0
      }, // 结果
      // 从快麦ERP导入
      erp_resultVisible: false,
      erp_resultData: {
        successNum: 0,
        totalNum: 0
      }, // 下载商品结果
      // 从分销商品导入
      dis_resultVisible: false,
      dis_resultData: {
        successNum: 0,
        totalNum: 0
      },
      // 从供销商展架导入
      sup_resultVisible: false,
      sup_resultData: {
        successNum: 0,
        totalNum: 0
      },
      subCode: '',
    }
  },
  computed: {
    ...mapGetters(['subCodeMap']),
  },
  methods: {
    ...mapActions(['fetch_channelByType']),
    search() {
      this.pagination.pageNo = 1;
      this.fetch_operatorLog();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_operatorLog();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_operatorLog();
    },
    async fetch_operatorLog() {
      const searchParams = this.$refs.search.method_getSearchForm();
      let { subCode } = searchParams;
      this.subCode = subCode;
      const {pageNo, pageSize} = this.pagination;
      const _params = {
        ...searchParams,
        operationType: 1,
        pageNo,
        pageSize
      }
      const res = await getOperatorLog(_params);
      if(!res) return;
      const {records, total} = res;
      this.logList = records;
      this.pagination.total = total;
    },
    // 展示弹窗
    showDownProgress(rowData) {
      const subCode = this.subCodeMap[rowData.channel];
      if( subCode == 1) {
        // 从平台店铺下载
        this.fetch_JobResult('DOWNLOAD_PLATFORM_ITEM', rowData)
      } else if(subCode == 2) {
        // 从快麦ERP导入
        this.fetch_erp_JobResult('IMPORT_ERP_ITEM', rowData)
      } else if(subCode == 4) {
        this.fetch_dis_JobResult('IMPORT_DISTRIBUTOR_ITEM', rowData)
      } else if(subCode == 5) {
        this.fetch_sup_JobResult('IMPORT_DISTRIBUTOR_ITEM', rowData)
      }

    },
    // 从平台店铺下载进度查询
    fetch_JobResult(taskTypeEnum, rowData) {
      this.$refs.progressDialog.showDialog()
      this.$refs.progressDialog.calculation_progress(rowData.total)
      this.$refs.progressDialog.queryScmJobResult(taskTypeEnum, (res) => {
        if(res.finished) {
          this.resultData = {...res.result}
          this.resultVisible = true;
        }
      })
    },
    // erp导入进度查询
    fetch_erp_JobResult(taskTypeEnum, rowData) {
      this.$refs.erp_progressDialog.showDialog()
      this.$refs.erp_progressDialog.calculation_progress(rowData.total)
      this.$refs.erp_progressDialog.queryScmJobResult(taskTypeEnum, (res) => {
        if(res.finished) {
          this.erp_resultData = {...res.result}
          this.erp_resultVisible = true;
        }
      })
    },
    // 分销商品导入进度查询
    fetch_dis_JobResult(taskTypeEnum, rowData) {
      this.$refs.dis_progressDialog.showDialog()
      this.$refs.dis_progressDialog.calculation_progress(rowData.total)
      this.$refs.dis_progressDialog.queryJobResult({
            taskTypeEnum: taskTypeEnum
          }, (res) => {
        if(res.finished) {
          this.dis_resultData = {...res.result}
          this.dis_resultVisible = true;
        }
      })
    },
    // 供销商展架导入进度查询
    fetch_sup_JobResult(taskTypeEnum, rowData) {
      this.$refs.sup_progressDialog.showDialog()
      this.$refs.sup_progressDialog.calculation_progress(rowData.total)
      this.$refs.sup_progressDialog.queryJobResult({
            taskTypeEnum: taskTypeEnum
          }, (res) => {
        if(res.finished) {
          this.sup_resultData = {...res.result};
          this.sup_resultVisible = true;
        }
      })
    },
  },
  mounted() {
    this.search();
    // 获取途径
    this.fetch_channelByType({
      type: 1
    });
  },
  deactivated() {
    this.$refs.progressDialog.handleClose();
    this.$refs.erp_progressDialog.handleClose();
    this.$refs.dis_progressDialog.handleClose();
    this.$refs.sup_progressDialog.handleClose();
  }
}
</script>

<style lang="scss" scoped>
.down-title {
  font-size: 18px;
  padding-bottom: 20px;
  display: inline-block;
  font-weight: 800;
}
</style>
